/**
 * Route công khai cho khách xem album — nằm NGOÀI `_app` nên không qua cổng
 * đăng nhập. Token trên đường dẫn là quyền duy nhất.
 *
 * File này cố tình chỉ khai báo route, không dựng component nào — cùng khuôn
 * `photo-select.tsx`, để cả thư mục tính năng lint sạch.
 */

import { createFileRoute } from "@tanstack/react-router";
import { AlbumShareRoute } from "@/features/album-share/AlbumShareRoute";

export const Route = createFileRoute("/album/$token")({
  component: AlbumShareRoute,
});
